const generateImagePaths = (prefix, count) => {
  const paths = [];
  for (let i = 1; i <= count; i++) {
    paths.push(`${prefix}-${String(i).padStart(2, '0')}.png`);
  }
  return paths;
};

const shortImagePaths = generateImagePaths('short', 11);
const longImagePaths = generateImagePaths('long', 31);

const imagesShort = shortImagePaths.map(path =>
  require(`../../images/pitch-deck/short/${path}`)
);

const imagesLong = longImagePaths.map(path =>
  require(`../../images/pitch-deck/long/${path}`)
);

export { imagesShort, imagesLong };



// WEBPACK FOOTER //
// ./src/components/PitchDeck/images.js